import { createAgreementFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-agreement'
import { createButtonFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-button'
import { createCouponFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-coupon'
import { createCustomLoginFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-custom-login'
import { createPaidCalendarFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-paid-calendar-from-library'
import { createTwoStepPaymentFormFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-two-step-payment-form'
import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import { OldEntityWithChildIds } from 'common/types/entities/OldEntityInterface'
import { EntitiesStructure } from 'common/types/Page'
import { createSearchFromLibrary } from 'src/editor/layout/sidebar/library/creators/create-search'
import { createAudio } from 'src/shared/entities/audio/create-audio'
import { createBlogCategoryDescription } from 'src/shared/entities/blog-category-description/create-blog-category-description'
import { createBlogCategoryTitle } from 'src/shared/entities/blog-category-title/create-blog-category-title'
import { createBlogContentPlaceholder } from 'src/shared/entities/blog-content-placeholder/create-blog-content-placeholder'
import { createBlogLatestPosts } from 'src/shared/entities/blog-latest-posts/create-blog-latest-posts'
import { createBlogPostCategories } from 'src/shared/entities/blog-post-categories/create-blog-post-categories'
import { createBlogPostContentPlaceholder } from 'src/shared/entities/blog-post-content-placeholder/create-blog-post-content-placeholder'
import { createBlogPostDate } from 'src/shared/entities/blog-post-date/create-blog-post-date'
import { createBlogPostImage } from 'src/shared/entities/blog-post-image/create-blog-post-image'
import { createBlogPostListing } from 'src/shared/entities/blog-post-listing/create-blog-post-listing'
import { createBlogPostTitle } from 'src/shared/entities/blog-post-title/create-blog-post-title'
import { createBreadcrumbs } from 'src/shared/entities/breadcrumbs/create-breadcrumbs'
import { createBulletList } from 'src/shared/entities/bullet-list/create-bullet-list'
import { createCountdown } from 'src/shared/entities/countdown/create-countdown'
import { createCustomerType } from 'src/shared/entities/customer-type/create-customer-type'
import { createFacebookComments } from 'src/shared/entities/facebook-comments/create-facebook-comments'
import { createField } from 'src/shared/entities/field/create-field'
import { createHorizontalLine } from 'src/shared/entities/horizontal-line/create-horizontal-line'
import { createImage } from 'src/shared/entities/image/create-image'
import { createLanguageSwitcher } from 'src/shared/entities/language-switcher/create-language-switcher'
import { createLatestBlogPostsCarousel } from 'src/shared/entities/latest-blog-posts-carousel/create-latest-blog-posts-carousel'
import { createOfferPrice } from 'src/shared/entities/offer-price/create-offer-price'
import { createOrderSummary } from 'src/shared/entities/order-summary/create-order-summary'
import { createPaymentMethod } from 'src/shared/entities/payment-method/create-payment-method'
import { createPriceElement } from 'src/shared/entities/price-element/create-price-element'
import { createProduct } from 'src/shared/entities/product/create-product'
import { createRawHtml } from 'src/shared/entities/raw-html/create-raw-html'
import { createSearchResults } from 'src/shared/entities/search-results/create-search-results'
import { createShippingFees } from 'src/shared/entities/shipping-fees/create-shipping-fees'
import { createText } from 'src/shared/entities/text/create-text'
import { createTwitterTweetButton } from 'src/shared/entities/twitter-tweet-button/create-twitter-tweet-button'
import { createVideo } from 'src/shared/entities/video/create-video'
import { createWebinarRegistrationDate } from 'src/shared/entities/webinar-registration-date/create-webinar-registration-date'
import { createWebinarSessionDateTime } from 'src/shared/entities/webinar-session-date-time/create-webinar-session-date-time'
import { createWebinarSessionLink } from 'src/shared/entities/webinar-session-link/create-webinar-session-link'
import { BaseEntityWithChildIdsInterface } from 'src/shared/schemas/base-entity.schema'
import { ContainerBaseEntityInterface } from 'src/shared/schemas/container-base-entity.schema'
import { ColumnTypeEnum } from '../../common/components/entities/Column/enums/ColumnTypeEnum'
import { createOrderBumpFromLibrary } from '../components/core/Sidebar/components/Toolbox/creators/create-order-bump'
import LibraryElementEnum from '../enums/LibraryElementEnum'
import {
  createCalendarFromLibrary,
  createCarouselFromLibrary,
  createCheckboxFromLibrary,
  createContactUsFromLibrary,
  createContentBoxFromLibrary,
  createContentTableFromLibrary,
  createDefaultEntityStructure,
  createFaqFromLibrary,
  createHeadlineFromLibrary,
  createOptInRecaptchaFromLibrary,
  createPaymentButtonFromLibrary,
  createRowFromLibrary,
  createSalesRedirectionButtonFromLibrary,
  createSectionFromLibrary,
  createSurveyFromLibrary,
  createUpsellAgreeButtonFromLibrary,
  createUpsellDisagreeButtonFromLibrary,
  createWebinarCallToActionFromLibrary,
  createWebinarSessionVideoFromLibrary,
} from './createStructureUtils'

export default function createLibraryElementStructure({
  libraryElementType,
  container,
  locale,
  position = 0,
}: {
  libraryElementType: LibraryElementEnum
  container: OldEntityWithChildIds | BaseEntityWithChildIdsInterface
  locale: string
  position?: number
}) {
  let structure: EntitiesStructure
  switch (libraryElementType) {
    case LibraryElementEnum.LibraryImage:
      structure = createDefaultEntityStructure({
        createEntity: createImage,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryFaq:
      structure = createFaqFromLibrary(container, locale, position)
      break

    case LibraryElementEnum.LibraryPriceElement:
      structure = createDefaultEntityStructure({
        createEntity: createPriceElement,
        container,
        locale,
        position,
      })
      break

    case LibraryElementEnum.LibraryWebinarRegistrationDate:
      structure = createDefaultEntityStructure({
        createEntity: createWebinarRegistrationDate,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryOrderSummary:
      structure = createDefaultEntityStructure({
        createEntity: createOrderSummary,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryText:
      structure = createDefaultEntityStructure({
        createEntity: createText,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryHeadline:
      structure = createHeadlineFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryCustomLogin:
      structure = createCustomLoginFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryBlogPostImage:
      structure = createDefaultEntityStructure({
        createEntity: createBlogPostImage,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryContentTable:
      structure = createContentTableFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryContactUs:
      structure = createContactUsFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryBreadcrumbs:
      structure = createDefaultEntityStructure({
        createEntity: createBreadcrumbs,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryCarousel:
      structure = createCarouselFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryBlogPostDate:
      structure = createDefaultEntityStructure({
        createEntity: createBlogPostDate,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryBlogPostListing:
      structure = createDefaultEntityStructure({
        createEntity: createBlogPostListing,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryBlogLatestPosts:
      structure = createDefaultEntityStructure({
        createEntity: createBlogLatestPosts,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryBlogPostTitle:
      structure = createDefaultEntityStructure({
        createEntity: createBlogPostTitle,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibrarySearchResults:
      structure = createDefaultEntityStructure({
        createEntity: createSearchResults,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibrarySearch:
      structure = createSearchFromLibrary(
        container as ContainerBaseEntityInterface,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibrarySurvey:
      structure = createSurveyFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryUpsellAgreeButton:
      structure = createUpsellAgreeButtonFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryUpsellDisagreeButton:
      structure = createUpsellDisagreeButtonFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryBlogPostCategories:
      structure = createDefaultEntityStructure({
        createEntity: createBlogPostCategories,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryBlogContentPlaceholder:
      structure = createDefaultEntityStructure({
        createEntity: createBlogContentPlaceholder,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryBlogPostBody:
      structure = createDefaultEntityStructure({
        createEntity: createBlogPostContentPlaceholder,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryVideo:
      structure = createDefaultEntityStructure({
        createEntity: createVideo,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryWebinarSessionVideo:
      structure = createWebinarSessionVideoFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryWebinarCallToAction:
      structure = createWebinarCallToActionFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryHorizontalLine:
      structure = createDefaultEntityStructure({
        createEntity: createHorizontalLine,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryBlogCategoryTitle:
      structure = createDefaultEntityStructure({
        createEntity: createBlogCategoryTitle,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryBlogCategoryDescription:
      structure = createDefaultEntityStructure({
        createEntity: createBlogCategoryDescription,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryWebinarSessionLink:
      structure = createDefaultEntityStructure({
        createEntity: createWebinarSessionLink,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryWebinarSessionDateTime:
      structure = createDefaultEntityStructure({
        createEntity: createWebinarSessionDateTime,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryOfferPrice:
      structure = createDefaultEntityStructure({
        createEntity: createOfferPrice,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryProduct:
      structure = createDefaultEntityStructure({
        createEntity: createProduct,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryOrderBump:
      structure = createOrderBumpFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryLatestBlogPostsCarousel:
      structure = createDefaultEntityStructure({
        createEntity: createLatestBlogPostsCarousel,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryField:
      structure = createDefaultEntityStructure({
        createEntity: createField,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibraryAudio:
      structure = createDefaultEntityStructure({
        createEntity: createAudio,
        container,
        locale,
        position,
      })
      break
    case LibraryElementEnum.LibrarySalesRedirectionButton:
      structure = createSalesRedirectionButtonFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryFacebookComments: {
      structure = createDefaultEntityStructure({
        createEntity: createFacebookComments,
        container,
        locale,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryOptInRecaptcha: {
      structure = createOptInRecaptchaFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryTwitterTweetButton: {
      structure = createDefaultEntityStructure({
        createEntity: createTwitterTweetButton,
        container,
        locale,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryCountdown: {
      structure = createDefaultEntityStructure({
        createEntity: createCountdown,
        container,
        locale,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryLanguageSwitcher: {
      structure = createDefaultEntityStructure({
        createEntity: createLanguageSwitcher,
        container,
        locale,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryCustomerType: {
      structure = createDefaultEntityStructure({
        createEntity: createCustomerType,
        container,
        locale,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryContentBox: {
      structure = createContentBoxFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryPaymentMethod: {
      structure = createDefaultEntityStructure({
        createEntity: createPaymentMethod,
        container,
        locale,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryRow: {
      structure = createRowFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryRawHTML: {
      structure = createDefaultEntityStructure({
        createEntity: createRawHtml,
        container,
        locale,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryCheckbox: {
      structure = createCheckboxFromLibrary(container, locale, position)
      break
    }

    case LibraryElementEnum.LibraryBulletList: {
      structure = createDefaultEntityStructure({
        createEntity: createBulletList,
        container,
        locale,
        position,
      })
      break
    }

    case LibraryElementEnum.LibraryCalendar: {
      structure = createCalendarFromLibrary(container, locale, position)
      break
    }

    case LibraryElementEnum.LibraryPaidCalendar: {
      structure = createPaidCalendarFromLibrary(container, locale, position)
      break
    }

    case LibraryElementEnum.LibraryColumn6: {
      structure = createRowFromLibrary(
        container,
        locale,
        position,
        ColumnTypeEnum.COLUMN_6,
      )
      break
    }

    case LibraryElementEnum.LibraryColumn4: {
      structure = createRowFromLibrary(
        container,
        locale,
        position,
        ColumnTypeEnum.COLUMN_4,
      )
      break
    }

    case LibraryElementEnum.LibraryColumn3: {
      structure = createRowFromLibrary(
        container,
        locale,
        position,
        ColumnTypeEnum.COLUMN_3,
      )
      break
    }
    case LibraryElementEnum.LibrarySection: {
      structure = createSectionFromLibrary({
        container: container,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryShippingFees: {
      structure = createDefaultEntityStructure({
        createEntity: createShippingFees,
        container,
        locale,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryPaymentButton: {
      structure = createPaymentButtonFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryCoupon: {
      structure = createCouponFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryAgreement: {
      structure = createAgreementFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryButton: {
      structure = createButtonFromLibrary({
        container,
        locale,
        position,
      })
      break
    }
    case LibraryElementEnum.LibraryOpenUrlButton: {
      structure = createButtonFromLibrary({
        container,
        locale,
        position,
        options: {
          action: ButtonActionTypeEnum.OpenUrl,
        },
      })
      break
    }
    case LibraryElementEnum.LibraryTwoStepPaymentForm: {
      structure = createTwoStepPaymentFormFromLibrary(
        container,
        locale,
        position,
      )
      break
    }
    default:
      throw new Error('unknown library type')
  }
  return structure
}
